<template>
    <card minify="true">
        <card-header>
            <card-overline>
                <translate>Details zur Anfrage</translate>
            </card-overline>
        </card-header>
        <card-content>
            <div class="row">
                <div class="col">
                    <description-group grid="true">
                        <description-element :caption="deliveryWish" :title="this.$gettext('Wunschlieferzeit Kunde')" />
                        <description-element :caption="offerValidity" :title="this.$gettext('Angebot gültig bis')" />
                        <description-element :caption="bidRoundEnding" :title="this.$gettext('Editierbar bis')" />
                        <description-element :caption="requiredMethods" :title="this.$gettext('Verfahren')" />
                        <description-element :caption="askForQuote.bid_rounds[0].bid_round_member_offers_count" :title="this.$gettext('Bisher erhaltene Angebote')" />
                    </description-group>
                </div>
            </div>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
export default {
    name: 'ComponentSidebarInquiry',
    components: {DescriptionElement, DescriptionGroup, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
        abilities: Object,
    },
    computed: {
        bidRoundEnding() {
            return this.$moment(this.askForQuote.bid_rounds[0].ending_at).format('DD.MM.YYYY HH') + ':00 '+this.$gettext('Uhr');
        },
        offerValidity() {
            let offerValidiy = this.$moment(this.askForQuote.bid_rounds[0].ending_at).add(this.askForQuote.bid_rounds[0].p_custom_offer_validity, 'days');
            if (!offerValidiy.isBusinessDay() || offerValidiy.isHoliday()) {
                offerValidiy = offerValidiy.nextBusinessDay();
            }
            return offerValidiy.format('DD.MM.YYYY');
        },
        deliveryWish() {
            // const deliveryDate = this.$moment(this.askForQuote.bid_rounds[0].ask_for_quote.delivery_date);
            // return this.$moment(this.askForQuote.bid_rounds[0].ending_at).businessDiff(deliveryDate) + ' Kalendertage';
            return this.askForQuote.bid_rounds[0].delivery_days_for_producer + ' ' + this.$gettext('Kalendertage');
        },
        requiredMethods() {
            let items = [];
            for (const [key] of Object.entries(this.abilities.methods)) {
                this.abilities.methods[key].forEach((method) => {
                    if (this.askForQuote.abilities?.methods[key][method[0]]) {
                        items.push(this.$gettext(method[1]));
                    }
                });
            }

            return items.join(', ');
        }
    }
};
</script>
